import Record from "slotworks/model/gameplay/records/record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

class SymbolSubstituteSupplement implements DataProcessorSupplement {
    public replacements: Map<string, string> = new Map<string, string>();

    public process(record: Record) {
        if (record && record instanceof SpinRecord) {
            if (record.grid) {
                for (const reel of record.grid) {
                    for (let y = 0; y < reel.length; y++) {
                        if (this.replacements.has(reel[y])) {
                            reel[y] = this.replacements.get(reel[y]);
                        }
                    }
                }
            }
        }
    }
}

export default new SymbolSubstituteSupplement();
